export enum RmcrType {
    AvoidableSwapFailures = 1,
    PreselectReversals = 2,
    PreselectAverage = 3,
    DataCompliance = 4,
    NcsDeficit = 5,
    SurgeryDateDeclines = 6,
    DrrAndXmResultsLate = 7,
    DonorReviewLate = 8,
    FinalXmResultsLate = 9,
    SerologyResultsLate = 10,
    BloodDrawsOutsideWindow = 11,
    UnprotectedReferrals = 12,
    ChainEndDeclineRatio = 13,
    OnTimeKidneyPickup = 14
}